'use strict';

const UART_TYPE = {
    0x00: "DEBUG",
    0x01: "RS485",
    0x02: "RS232"
};

let UART_PARITY = {
    0x00: "NONE",
    0x01: "ODD",
    0x02: "EVEN"
};

let PROTOCAL = {
    0x00: "TCP",
    0x01: "UDP",
};

function parse(reader) {
    reader.readUInt8('data.params.uart_type', value => UART_TYPE[value]);
    reader.readUInt32LE('data.params.baud');
    reader.readUInt8('data.params.data_bits');
    reader.readUInt8('data.params.stop_bits');
    reader.readUInt8('data.params.parity', value => UART_PARITY[value]);
    reader.readUInt8('data.params.flow');
    reader.readUInt8('data.params.mode');
    reader.readUInt8('data.params.enable');
    reader.readUInt8('data.params.protocol', value => PROTOCAL[value]);
    reader.readUInt16LE('data.params.keep_alive_interval');
    reader.readUInt16LE('data.params.reserve');
    reader.readUInt16LE('data.params.keep_alive_max_retries');
    reader.readUInt16LE('data.params.frame_bytes');
    reader.readUInt16LE('data.params.frame_interval');
    reader.readString(32, 'data.params.register_package');
    for (let i = 1; i <= 2; i++) {
        reader.readUInt8(`data.params.destination_${i}.server_ip.1`);
        reader.readUInt8(`data.params.destination_${i}.server_ip.2`);
        reader.readUInt8(`data.params.destination_${i}.server_ip.3`);
        reader.readUInt8(`data.params.destination_${i}.server_ip.4`);
        reader.readUInt16LE(`data.params.destination_${i}.server_port`);
    }
}

module.exports.parse = parse;



// WEBPACK FOOTER //
// ./src/lib/ucp/parsers/mode/cloud/v1_2/common/rule/uart-mode-parser.js